module.exports = __webpack_public_path__ + "img/logo.23d76d3e.png";